import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import { map } from 'lodash';
import HeaderDropdown from "./header-dropdown";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';


const oecdBaseUrl = 'https://www.oecd.org';

const getHeaderMenuItems = (language) => [
  {
    label: 'OECD.org',
    link: `${oecdBaseUrl}/`,
    uiKey: 'oecd',
  },
  {
    label: 'Data',
    link: `${oecdBaseUrl}/${language}/data/`,
    uiKey: 'data',
  },
  {
    label: 'Publications',
    link: `${oecdBaseUrl}/${language}/publications/`,
    uiKey: 'publications',
  },
  {
    label: 'OECD Legal Instruments',
    link: '#',
    uiKey: 'legalInstruments',
  },
  {
    label: 'News & Events',
    link: `${oecdBaseUrl}/${language}/news-events/`,
    uiKey: 'news-events',
  },
  {
    label: 'About',
    link: `${oecdBaseUrl}/${language}/about/`,
    uiKey: 'about',
  }
];

const menuItemLinkStyle = {
  color: '#1a2126',
  textDecoration: 'none',
}

const legInstrumentStyle = {
  ...menuItemLinkStyle,
  fontWeight: 'bold',
};

const Header = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  const headerMenuItems = getHeaderMenuItems(lang);

  return (
    <AppBar
      position="static"
      className={'hidePrint'}
      color="transparent"
      sx={{
        backgroundColor: '#fff',
      }}>
      <Toolbar
        variant="dense"
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <Grid container justifyContent="center" spacing={3}>
          {map(headerMenuItems, item => {
            const linkStyle = item.uiKey === 'legalInstruments' ? legInstrumentStyle : menuItemLinkStyle;
            return (
              <Grid item key={item.uiKey}>
                {item.subMenu
                  ? <HeaderDropdown menuItem={item}/>
                  : <a href={item.link} style={linkStyle} target="_blank">
                      {t(item.label)}
                    </a>
                }
              </Grid>
            )
          })}
        </Grid>
      </Toolbar>
    </AppBar>
  )
};

export default Header;
